import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment.development';

@Component({
  selector: 'app-page-unauthorized',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './page-unauthorized.component.html',
  styleUrl: './page-unauthorized.component.scss'
})
export class PageUnauthorizedComponent {
  goBackToIntranetWeb(){
    window.location.href = environment.url.apiIntranet;
  }
}
